import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import AppSidebar from "./AppSidebar";

const { Content } = Layout;
const SIDEBAR_COLLAPSED_KEY = "app_sidebar_collapsed";

function AppLayout() {
    const [collapsed, setCollapsed] = useState(() => {
        return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
    });

    useEffect(() => {
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed));
    }, [collapsed]);

    const sidebarWidth = collapsed ? 80 : 240;

    return (
        <Layout className="min-h-screen bg-slate-50">
            <AppSidebar collapsed={collapsed} setCollapsed={setCollapsed} />

            <Layout
                className="min-h-screen transition-all duration-300"
                style={{ marginLeft: sidebarWidth }}
            >
                <Content
                    className="min-h-screen bg-slate-50"
                    style={{
                        padding: 20,
                    }}
                >
                    <div style={{ maxWidth: 1680, margin: "0 auto" }}>
                        <Outlet />
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
}

export default AppLayout;